// version v2.0.0

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {

  const getInitialCart = () => {
    try {
      const user = localStorage.getItem('user');

      // No logged-in user = empty cart
      if (!user) {
        localStorage.removeItem('cart');
        return [];
      }

      const savedCart = localStorage.getItem('cart');

      return savedCart ? JSON.parse(savedCart) : [];

    } catch (error) {
      console.error('Failed loading cart:', error);
      return [];
    }
  };

  const [cart, setCart] = useState(getInitialCart);
  const [warning, setWarning] = useState(false);

  // ==================================================
  // CLEAR CART IF USER LOGS OUT
  // ==================================================
  useEffect(() => {

    const checkAuth = () => {

      const user = localStorage.getItem('user');

      if (!user) {

        setCart([]);
        localStorage.removeItem('cart');

      }
    };

    checkAuth();

    window.addEventListener('storage', checkAuth);

    return () => {
      window.removeEventListener('storage', checkAuth);
    };

  }, []);

  // ==================================================
  // ADD TO CART
  // ==================================================
  const addToCart = (item) => {

    setCart(prevCart => {

      const exists = prevCart.find(
        product => product._id === item._id
      );

      if (exists) {

        setWarning(true);

        return prevCart;
      }

      return [
        ...prevCart,
        {
          ...item,
          quantity: 1
        }
      ];
    });
  };

  // ==================================================
  // REMOVE ITEM
  // ==================================================
  const removeFromCart = (productId) => {

    setCart(prev =>
      prev.filter(item => item._id !== productId)
    );
  };

  // ==================================================
  // INCREASE
  // ==================================================
  const increaseQuantity = (productId) => {

    setCart(prev =>
      prev.map(item =>
        item._id === productId
          ? {
              ...item,
              quantity: item.quantity + 1
            }
          : item
      )
    );
  };

  // ==================================================
  // DECREASE
  // ==================================================
  const decreaseQuantity = (productId) => {

    setCart(prev =>
      prev.map(item =>
        item._id === productId
          ? {
              ...item,
              quantity: Math.max(
                1,
                item.quantity - 1
              )
            }
          : item
      )
    );
  };

  // ==================================================
  // CLEAR CART
  // ==================================================
  const resetCart = () => {

    setCart([]);
    localStorage.removeItem('cart');
  };

  // ==================================================
  // SAVE CART
  // ==================================================
  useEffect(() => {

    try {

      const user = localStorage.getItem('user');

      if (!user) {

        localStorage.removeItem('cart');
        return;
      }

      localStorage.setItem(
        'cart',
        JSON.stringify(cart)
      );

    } catch (error) {

      console.error(
        'Failed saving cart:',
        error
      );
    }

  }, [cart]);

  return (
    <CartContext.Provider
      value={{
        cart,
        warning,
        setWarning,
        addToCart,
        removeFromCart,
        increaseQuantity,
        decreaseQuantity,
        resetCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};